/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, KeyboardEvent, MouseEvent } from 'react';
import clsx from 'clsx';
import { PopupHeaderProps } from '../Modal.types';
import { StyledPopupHeaderDiv, StyledCloseDiv } from './index.styles';
import { useCheckBreakpoint } from '../../../hooks';
import { Heading } from '../../../atoms/Heading';
import { headingType, tags } from '../../../utils/enums/enums';

declare module 'react' {
  interface HTMLAttributes<T> {
    custom_click_track_value?: string;
  }
}

const PopupHeader: FC<PopupHeaderProps> = ({
  className,
  labelText,
  popupHeaderOnCLoseFunc,
  popupCloseClassName,
  headingTagElement = tags.h4,
  closeIconClickTrackValue,
  customHeadingClass,
  closeBtnAriaLabel,
  popupCloseIconClassName,
  flexLayout,
}) => {
  const closePopup = (): void => {
    popupHeaderOnCLoseFunc?.(false);
  };

  const handleClick = (event: MouseEvent<HTMLDivElement>): void => {
    if (popupHeaderOnCLoseFunc) {
      event.preventDefault();
      event.stopPropagation();
      closePopup();
    }
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>): void => {
    if (popupHeaderOnCLoseFunc && (event.key === 'Enter' || event.key === ' ')) {
      // Prevent Enter/Space from triggering ancestor submit or reopen handlers.
      event.preventDefault();
      event.stopPropagation();
      closePopup();
    }
  };
  const isDesktop = useCheckBreakpoint('viewportM'); // check if viewport is desktop till 768px
  const clickTrackingLoc = 'Phoenix Search Results';
  return (
    <StyledPopupHeaderDiv className={className} flexLayout={flexLayout}>
      {labelText && (
        <Heading
          element={headingTagElement}
          variation={headingType.title}
          customClass={clsx(customHeadingClass ?? (isDesktop ? 't-subtitle-xl' : 't-font-m'), 'mb-0', 'header-heading')}
          titleText={labelText}
        />
      )}
      <div
        className={clsx('popup-close', 'custom_click_track', popupCloseClassName)}
        tabIndex={0}
        role="button"
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        {...{
          custom_click_track_value: closeIconClickTrackValue
            ? closeIconClickTrackValue
            : `${clickTrackingLoc}| Close Button |internal`,
        }}
        aria-label={closeBtnAriaLabel || 'Close pop up'}
      >
        <StyledCloseDiv className={clsx('icon-clear', popupCloseIconClassName)}></StyledCloseDiv>
      </div>
    </StyledPopupHeaderDiv>
  );
};

export default PopupHeader;
